import { render } from "./EnbPagamentos.vue?vue&type=template&id=5247f15e&scoped=true"
import script from "./EnbPagamentos.vue?vue&type=script&lang=js"
export * from "./EnbPagamentos.vue?vue&type=script&lang=js"

import "./EnbPagamentos.vue?vue&type=style&index=0&id=5247f15e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5247f15e"]])

export default __exports__